<template>
    <div class="notification-custom">
        <data-form title="Custom Notification"
                   save-button-label="Send"
                   :field-model="notificationCustom"
                   :field-groups="fieldGroups"
                   :on-submit-handler="onSubmit"
                   :load-model-instance="loadModel"
                   cancelRoute="/notifications"

                   submit-success-message="Notifications sent"
                   submit-error-message="Error generating notifications"/>
    </div>
</template>

<script>
import NotificationCustom from "@/models/NotificationCustom";

export default {
    name: "NotificationCustom",
    data () {
        return {
            notificationCustom: NotificationCustom,
            fieldGroups: [['role_groups', 'subject', 'message']],
        }
    },
    methods: {
        onSubmit(modelInstance) {
            return this.$api.sendCustomNotification(this, modelInstance)
        },
        loadModel() {
            return Promise.resolve({})
        },
    }

}
</script>

<style lang="scss">
    .notification-custom {
        max-width:900px;
        margin: 0 auto;
    }

</style>